import React from 'react';
import ReactPaginate from 'react-paginate';
const ReactPagination = ({ pageCount, onPageChange, currentPage }) => {
    return (
        <ReactPaginate
            previousLabel={<i class="fa-solid fa-chevron-left"></i>}
            nextLabel={<i class="fa-solid fa-chevron-right"></i>}
            breakLabel={'...'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={onPageChange}
            containerClassName={'pagination'}
            activeClassName={'active'}
            forcePage={currentPage}
        />
    )
}

export default ReactPagination;